//MassBalanceFilter
import '../../styles/TableFilter.css'

import { useState, useEffect }  from 'react';
import { useUser }              from '../../contexts/UserContext';
import { useMassBalancePage }   from '../../contexts/MassBalancePageContext';
import SelectTerminal           from '../InputsFilled/SelectTerminal'
import DatepickerMassBalance    from '../InputsFilled/DatepickerMassBalance'
import { findPermission }       from '../../utils/UserPermissionUtils.js';
import { ReactComponent as IconSwap } from '../../assets/Icons/icon-swap.svg'




function MassBalanceFilter({ onOpenMassBalanceModal }) {

    const [_hasPermission, _setHasPermission] = useState(false);
    const { userData } = useUser();
    const { selectedViewType, setSelectedViewType } = useMassBalancePage();

    const isTabela = selectedViewType === 'tabela';

    return (

        <section
            className="w-full bg-neutro borda-cinza rounded-[7px] p-[1rem] flex justify-between gap-[10px]"
        >

        <div className="flex flex-row gap-2">

            <SelectTerminal />
            <DatepickerMassBalance  />
            
            {findPermission(userData, "Edição Balanço de Massa") && (
                        
                <button
                    type="button"
                    title={isTabela ? 'Ver Heatmap' : 'Ver Tabela'}
                    aria-label={isTabela ? 'Ver Heatmap' : 'Ver Tabela'}
                    onClick={() => setSelectedViewType(isTabela ? 'heatmap' : 'tabela')}
                    className={`flex items-center justify-center h-10 w-10 rounded-[4px] border-[none] cursor-pointer [transition:0.3s_ease] ${isTabela ? 'bg-azul-profundo-m text-white' : 'bg-white text-black hover:bg-azul-profundo-c hover:text-white'}`}
                >
                    <IconSwap className={`w-5 h-5 ${isTabela ? '[&_path]:stroke-white' : ''}`} />
                </button>

            )}
       
        </div>

        {findPermission(userData, 'Edição Balanço de Massa') && (
            <button
                className=" flex mr-15px ml-auto btn bg-azul-profundo-m hover:bg-azul-profundo-e z-10 h-10 items-center"
                onClick={onOpenMassBalanceModal}
            >
                Enviar BM
            </button>
        )}
        </section>
    )
}

export default MassBalanceFilter

